<template>
    <vx-expandable-card>
        <template v-slot:header>Documentation</template>
        <template v-slot:content>
            <div class="mb-2 font-semibold text-lg">Inbound Configuration</div>
            <div class="mb-6">
                Click <strong>Connect</strong> in the Inbound Configuration section to generate a
                <strong>Key</strong> and <strong>Secret</strong>. You'll need these to set up Cohort Sync and Event
                Streaming in Amplitude. Inbound and outbound can be configured independently.
            </div>

            <div class="mb-2 font-semibold">Cohort Sync</div>
            <ol class="list-decimal list-inside mb-6 space-y-1">
                <li>
                    In Amplitude, go to <strong>Data → Destinations</strong>, add Voxie, and paste your Key and Secret.
                </li>
                <li>
                    Open any cohort in Amplitude, click <strong>Sync</strong>, select the Voxie destination, and choose
                    which user properties to include. Make sure to include the user's <strong>phone number</strong>
                    property — it is required for Voxie to identify and sync contacts.
                </li>
            </ol>

            <div class="mb-2 font-semibold">Event Streaming</div>
            <ol class="list-decimal list-inside mb-10 space-y-1">
                <li>
                    In Amplitude, go to <strong>Data → Destinations</strong>, add Voxie, and paste your Key and Secret.
                </li>
                <li>
                    Map your Amplitude user properties to Voxie fields. <strong>Phone</strong> is required — contacts
                    without a phone number will be skipped.
                </li>
                <li>Enable the <strong>Send Users</strong> toggle to forward Identify calls to Voxie.</li>
                <li>
                    Optionally enable <strong>Send Events</strong> and filter to the specific event types you want to
                    forward.
                </li>
            </ol>

            <div class="mb-2 font-semibold text-lg">Outbound Configuration</div>
            <div class="mb-4">
                Enter your Amplitude API key in the Outbound Configuration section and click <strong>Connect</strong> to
                enable sending contacts and events from Voxie to Amplitude. You can find your API key in Amplitude under
                <strong>Organization settings → Connections → API Keys</strong>.
            </div>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard } from '@voxie/frontend-components';
</script>
